import request from "../../utils/request";

export function doGetAllOrdersDispatched(params) {
  return request("/orders/dispatched", {
    method: "GET",
    params,
  });
}

export function doGetCountOrdersDispatchedByCompany(params) {
  return request("/orders/companies-orders-dispatched", {
    method: "GET",
    params,
  });
}
